import { useRef } from 'react';

export const useSidebarResize = () => {
  const sidebarRef = useRef<HTMLDivElement>(null);

  return {
    sidebarRef,
  };
};
